import { Button, Popover } from "@mui/material";
import { styled } from '@mui/system';
import React from "react";
import * as PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const useStyles = styled((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
}));

const settings = {
    'top': {
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        transformOrigin: { vertical: 'bottom', horizontal: 'center' }
    },
    'left': {
        anchorOrigin: { vertical: 'center', horizontal: 'left' },
        transformOrigin: { vertical: 'center', horizontal: 'right' }
    },
    'right': {
        anchorOrigin: { vertical: 'center', horizontal: 'right' },
        transformOrigin: { vertical: 'center', horizontal: 'left' }
    },
}

const CompTooltipIcon = (props) => {
    const { orientation = "top", children, ignore = false, ...componentProps } = props;
    
    const { t } = useTranslation('translation');
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        if (ignore) {
            event.stopPropagation();
            event.preventDefault();
        }
        
        if (open) {
            handlePopoverClose();
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const orig = settings[orientation];

    let popover = null;
    let popoverOverlay = (<div />);

    if (open) {
        popover = (
            <Popover
                className={'tooltip-icon-popover ' + classes.popover}
                classes={{
                    paper: orientation + " " + classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: orig.anchorOrigin.vertical,
                    horizontal: orig.anchorOrigin.horizontal,
                }}
                transformOrigin={{
                    vertical: orig.transformOrigin.vertical,
                    horizontal: orig.transformOrigin.horizontal,
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                disableAutoFocus
                disableEnforceFocus
                {...componentProps}
            >
                <Typography>{children}</Typography>
            </Popover>
        )
        popoverOverlay = (
            <div 
                className={'popoverOverlay'} 
                onClick={handlePopoverOpen}
                onMouseDown={(e) => {
                    if (ignore) {
                        e.stopPropagation();
                        e.preventDefault(); 
                    }
                }}
                onTouchStart={(e) => {
                    if (ignore) {
                        e.stopPropagation();
                        e.preventDefault(); 
                    }
                }}
            />
        );
    }

    return (
        <span className={'tooltip-icon-container'}>
            <Button 
                style={{ padding: '0px', minWidth: 'auto' }} 
                onClick={handlePopoverOpen}
                onMouseDown={(e) => {
                    if (ignore) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }} 
                onTouchStart={(e) => {
                    if (ignore) {
                        e.stopPropagation();
                        e.preventDefault(); 
                    }
                }} 
            >
                <img 
                    className={`tooltip-icon-image ${open ? 'hidden' : ''}`}
                    src={process.env.PUBLIC_URL + '/media/images/icons/IconTooltipInfo.svg'}
                    alt={t('common.info')}
                />
                <img 
                    className={`tooltip-icon-image ${open ? '' : 'hidden'}`}
                    src={process.env.PUBLIC_URL + '/media/images/icons/IconTooltipInfoFocus.svg'}
                    alt={t('common.info')}
                />
            </Button>
            {popoverOverlay}
            {popover}
        </span>
    );
}

CompTooltipIcon.propTypes = {
    orientation: PropTypes.string,
    ignore: PropTypes.bool,
    children: PropTypes.node
};

export { CompTooltipIcon };